import { render, staticRenderFns } from "./FileForOrder.vue?vue&type=template&id=07a72b3a&scoped=true&"
import script from "./FileForOrder.vue?vue&type=script&lang=js&"
export * from "./FileForOrder.vue?vue&type=script&lang=js&"
import style0 from "./FileForOrder.vue?vue&type=style&index=0&id=07a72b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a72b3a",
  null
  
)

export default component.exports